import { render, staticRenderFns } from "./ProgramItem.vue?vue&type=template&id=422f44f2"
import script from "./ProgramItem.vue?vue&type=script&lang=js"
export * from "./ProgramItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports